import createReducer from '../createReducer'

const initialState = {
  domain: /mapmyfitness\.com$/,
  canonical: 'https://www.mapmyfitness.com/',
  name: 'MapMyFitness',
  plural: 'routes',
  apiKey: '',
  apiSecret: '',
  apiCallback: '',
  fbAppID: '',
  fbAppSecret: '',
  abbr: 'MMF',
  slug: 'fitness',
  shortName: 'mapmyfitness',
  noun: 'workout',
  action: 'training',
  legacySiteID: null,
  activityTypeID: 16,
  iosAppID: 298903147,
}

export default createReducer(initialState, {
// pass
})



// WEBPACK FOOTER //
// ./src/services/site/reducer.js